enum TimeSelection {
    Today = "Today",
    Yesterday = "Yesterday",
    ThisWeek = "This Week",
    Last7Days = "Last 7 Days",
    LastWeek = "Last Week",
    Last14Days = "Last 14 Days",
    ThisMonth = "This Month",
    Last30Days = "Last 30 Days",
    LastMonth = "Last Month",
    ThisYear = "This Year",
    LastYear = "Last Year"
}

// export default enum is not supported syntax
export default TimeSelection;
